import React, { useCallback } from "react";
import { useFormikContext } from "formik";

import Messengers from "components/InputsField/Messengers";

const FormikMessengers = ({ label, messengersList, name }) => {
    const { values, setFieldValue } = useFormikContext();

    const handleChangeFiled = useCallback(
        (value) => {
            if (!values[name]) {
                setFieldValue(name, [value]);
            } else if (values[name].find((el) => el.id === value.id)) {
                const deleteIndex = values[name].findIndex((el) => value.id === el.id);
                setFieldValue(name, [
                    ...values[name].slice(0, deleteIndex),
                    ...values[name].slice(deleteIndex + 1),
                ]);
            } else {
                setFieldValue(name, [...(values[name] || []), value]);
            }
        },
        [setFieldValue, name, values],
    );

    const handleMessagerChange = (item) => (el) => {
        const value = values[name].find((messenger) => messenger.id === item.id);
        value.messenger = el.target.value;

        setFieldValue(name, values[name]);
    };

    return (
        <Messengers
            label={label}
            messengersList={messengersList}
            activeMessengersList={values[name] || []}
            onMessengerClick={handleChangeFiled}
            onMessengerChange={handleMessagerChange}
        />
    );
};

export default FormikMessengers;
